module.exports = __webpack_public_path__ + "assets/img/meeting-image6.0f89293d.png";